import { createAsyncThunk } from "@reduxjs/toolkit";
import { postLoginService } from "../../Services";

// Get grouped orders for merchant
// export const getGroupedOrders = createAsyncThunk(
//     "order/getGroupedOrders",
//     async (_, { rejectWithValue }) => {
//         try {
//             const response = await postLoginService.get("/api/orders/merchant/grouped");
//             return response;
//         } catch (error) {
//             return rejectWithValue(
//                 error.response?.data?.message || "Failed to fetch orders"
//             );
//         }
//     }
// );

export const getWithItems = createAsyncThunk(
    "order/getWithItems",
    async (_, { rejectWithValue }) => {
        try {
            const response = await postLoginService.get("/api/orders/with-items");
            return response;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Failed to fetch orders"
            );
        }
    }
);

// Get order details by ID
export const getOrderDetails = createAsyncThunk(
    "order/getOrderDetails",
    async (orderId, { rejectWithValue }) => {
        try {
            const response = await postLoginService.get(`/api/orders/${orderId}`);
            return response;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Failed to fetch order details"
            );
        }
    }
);
